import { Step, StepContentProps, StepGroupProps, StepProps, StepTitleProps } from "semantic-ui-react";

type BPStepProps = StepProps & {}

export function BPStep(props: BPStepProps) {
    return <Step {...props}>{props.children}</Step>
}

type BPStepGroupProps = StepGroupProps & {}
export function BPStepGroup(props: BPStepGroupProps) {
    return <Step.Group {...props}>{props.children}</Step.Group>
}

type BPStepContentProps = StepContentProps & {}

export function BPStepContent(props: BPStepContentProps) {
    return <Step.Content {...props}>{props.children}</Step.Content>
}

type BPStepTitleProps = StepTitleProps & {}

export function BPStepTitle(props: BPStepTitleProps) {
    return <Step.Title {...props}>{props.children}</Step.Title>
}